module.exports = __webpack_public_path__ + "static/media/chevron-gray.2c234a5c.svg";